<template>
  <div id="app">
    <router-view/>
    <vue-snotify></vue-snotify>
  </div>
</template>

<script>
export default {
  beforeCreate() {
    if(this.$store.getters['auth/userLoggedIn']) {
      this.$store.dispatch('auth/setXAuthHeader');
    }
  }
}

</script>

<style lang="scss">
@import "assets/scss/all";

#app {
  overflow: auto;
  max-height: 1530px;
}

@media (max-width: 451px) {
  #app {
    max-height: 1350px;
  }
}

@media (min-width: 701px) {
  #app {
    max-height: 1000px;
  }
}

@media (min-width: 961px) {
  #app {
    max-height: 900px;
  }
}
  
</style>
 